import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Typography } from "@mui/material";

function ImageItem({ item }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.8, 1], [0, 1, 1, 0]);
  return (
    <>
      <motion.img
        className="hidden md:block sm:w-full md:w-4/5 h-[88vh] object-cover object-top"
        ref={ref}
        src={item.image}
        alt="Scrolling Visual"
        style={{
          opacity,
        }}
      />
      <div className="block md:hidden relative">
        <motion.img
          className="sm:w-full md:w-4/5 object-contain"
          src={item.image}
          alt="Scrolling Visual"
        />
        <div className="flex flex-col gap-3 bg-[#f6f6f797] p-4">
          <Typography
            variant="subtitle1"
            color="primary.dark"
            textTransform="uppercase"
            fontWeight={300}
            fontSize={12}
            letterSpacing={1}
          >
            Smart Home | Operating System
          </Typography>
          <Typography
            variant="h4"
            color="primary.content"
            textTransform="uppercase"
            fontSize={22}
          >
            <b>Your Home.</b> <span className="font-light">Simplified.</span>
          </Typography>
          <div className="relative w-full">
            <Typography fontSize={14}>{item.title}</Typography>
          </div>
          {/* <Button
            variant="outlined"
            sx={{
              py: 1,
              color: "#000",
              borderColor: "#000",
              "&:hover": {
                backgroundColor: "primary.dark",
                color: "primary.contrastText",
                borderColor: "primary.dark",
              },
            }}
          >
            {item.btn}
          </Button> */}
        </div>
      </div>
    </>
  );
}

export default ImageItem;
